import React, { useEffect, useState } from 'react';
import '../../styles/globals.css'
import { Box, Card, Typography, Grid, Grow, Link, Paper, Divider } from '@mui/material'
import karmaStyles from '../../styles/KarmaPool.module.css'
import DashboardMenuHeaderComponent from './header/DashboardMenuHeaderComponent';
import DashboardLogoutFooterComponent from './footer/DashboardLogoutFooterComponent';
import { useKarmaPoolContext } from '../../state/KarmaPoolContext';

import giveDirectlyLogo from '../../images/causes/icons/give-directly.png';
import evidenceActionLogo from '../../images/causes/icons/evidence-action.png';
import coolEarthLogo from '../../images/causes/icons/cool-earth.png';
import wildAnimalInitiativeLogo from '../../images/causes/icons/wild-animal-initiative.png';
import cleanAirTaskForceLogo from '../../images/causes/icons/clean-air-taskforce.png';
import msfLogo from '../../images/causes/icons/msf.png';

import HistoryIcon from '@mui/icons-material/History';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';


// Import relevant icons
import { InlineIcon } from '@iconify/react';


function Donationlog(proof, index) {

    function convertDateTime(dateTime) {
        // Convert from 2023-10-05T20:07:59 to 2023-10-05
        return dateTime.split("T")[0];
    }

    function getCauseIcon(proof) {
        if (proof.causeName === "Give Directly") {
            return giveDirectlyLogo;
        }

        if (proof.causeName === "Evidence Action") {
            return evidenceActionLogo;
        }

        if (proof.causeName === "Cool Earth") {
            return coolEarthLogo;
        }

        if (proof.causeName === "Wild Animal Initiative") {
            return wildAnimalInitiativeLogo;
        }

        if (proof.causeName === "Clean Air Task Force") {
            return cleanAirTaskForceLogo;
        }

        if (proof.causeName === "MSF") {
            return msfLogo;
        }

        return null;
    }

    return (
        <>
            <a href={proof.url} target="_blank" rel="noreferrer">
                <img src={getCauseIcon(proof)} alt="logo" width={40} height={40} />
            </a>
            <Box key={proof.id || index}
                sx={{
                    maxWidth: "14.55rem",
                    minWidth: "14.55rem",
                    width: "100.0%",
                    justifyContent: "left",
                    alignItems: "left",
                    padding: "0.5rem",
                    margin: "0.25rem",
                    marginRight: "0.5rem",
                    marginLeft: "0.75rem",
                    marginBottom: "0.375rem",
                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                    borderRadius: "0.25rem",
                    borderColor: "rgba(221, 221, 221, 0.25)",
                    border: "1px solid rgba(221, 221, 221, 0.35)",
                }}>
                <Grid container spacing={0}>
                    <Grid item xs={9} sm={9}>
                        <Box sx={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
                            <Typography variant="body2" color="text.secondary" sx={{ color: "smoke" }}>
                                {convertDateTime(proof.donationDateTime)}
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "left", justifyContent: "left" }}>
                            <Typography variant="body2" color="text.secondary" sx={{ color: "smoke" }}>
                                {proof.causeName === "MSF" ? "Doctors Without Borders" : proof.causeName}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Box sx={{ width: "100%", height: "100%", justifyContent: "center", marginTop: "0.5rem" }}>
                            <Typography variant="body2" color="text.secondary" sx={{ color: "smoke" }}>
                                £{proof.donationAmount.toFixed(2)}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

function DashboardPool() {

    const karmaContext = useKarmaPoolContext();

    function GetUserGbpToGoodCausesTo2DP() {
        if (karmaContext.local.user.gbpGivenByUserAllTime == null) {
            return "0.00";
        }

        return karmaContext.local.user.gbpGivenByUserAllTime.toFixed(2);
    }

    function GetUserGbpToThoseInNeed() {
        if (karmaContext.local.user.gbpToThoseInNeed == null) {
            return "0.00";
        }

        return karmaContext.local.user.gbpToThoseInNeed.toFixed(2);
    }

    const [poolSection, setPoolSection] = useState("general");

    function ChangeSelected(selected) {
        setPoolSection(selected);
    }

    const [donationProofs, setDonationProofs] = useState(null);

    useEffect(() => {
        karmaContext.donationProofManager.fetchLatestDonationProof();
    }, []);

    useEffect(() => {
        setDonationProofs(karmaContext.local.donationProofs);
    }, [karmaContext.local.donationProofs]);

    function renderDonationProofs() {
        console.log(donationProofs);

        if (donationProofs === undefined || donationProofs === null || donationProofs.length === 0) {
            return "Nothing yet :'(";
        }

        return (
            // Go through first 3 elements of donationProofs
            donationProofs.slice(0, 5).map((proof, index) => (
                <Box key={proof.id || index}
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                    {Donationlog(proof, index)}
                </Box>
            ))
        );
    };

    function BackButton() {
        return (
            <Box>
                <p className={karmaStyles.homepageDescription}>
                    <a href={"/karma/dashboard"}>
                        back
                    </a>
                </p>
            </Box>
        );
    }

    return (
        <>
            <Box className={karmaStyles.homepageBox2}>
                <DashboardMenuHeaderComponent
                    poolEnabled={true} />
            </Box>

            <Box className={karmaStyles.homepageBox3}>
                <Grid container spacing={1} sx={{ marginBottom: "1.0rem", marginTop: "-1.325rem" }}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                            <p> The <strong> Karma Pool </strong> currently has: </p>
                        </Typography>
                        <Grow in={true} >
                            <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", display: "flex", justifyContent: "center" }}>
                                <Card sx={{
                                    width: "40%",
                                    maxWidth: "38em",
                                    minWidth: "14em",
                                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                                    borderRadius: "0.25rem",
                                    borderColor: "rgba(221, 221, 221, 0.25)",
                                    border: "1px solid rgba(221, 221, 221, 0.35)",
                                    marginBottom: "0.5rem"

                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                                        <p> <strong> £{karmaContext.local.pool["gbpInPool"].toFixed(2)} </strong> in the pool </p>
                                        <p> <strong> £{karmaContext.local.cycle["gbpInCycle"].toFixed(2)} </strong> in the current cycle </p>
                                        <p> given <strong> £{karmaContext.local.pool.gbpGivenByPool}.00 </strong> to good causes</p>
                                    </Typography>
                                </Card>
                            </Box>
                        </Grow>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ marginTop: "-0.25rem", color: "whitesmoke" }}>
                        <Box sx={{}}>
                            <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                                <p> Your contribution: </p>
                            </Typography>

                            <Grow in={true} >
                                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", display: "flex", justifyContent: "center" }}>
                                    <Card sx={{
                                        width: "40%",
                                        maxWidth: "38em",
                                        minWidth: "14em",
                                        backgroundColor: "rgba(221, 221, 221, 0.075)",
                                        borderRadius: "0.25rem",
                                        borderColor: "rgba(221, 221, 221, 0.25)",
                                        border: "1px solid rgba(221, 221, 221, 0.35)",
                                        marginBottom: "0.5rem"
                                    }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                                            <p> <strong> £{GetUserGbpToGoodCausesTo2DP()} </strong> to good causes</p>
                                        </Typography>
                                    </Card>
                                </Box>
                            </Grow>
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ with: "100%", display: "flex", justifyContent: "center", marginTop: "-0.75rem" }}>
                    <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                        <p> Our latest donations:</p>
                    </Typography>
                    <Typography variant="body2" sx={{ color: "whitesmoke", fontSize: "0.825rem" }}>
                        {/*<p> Our latest donations: </p>*/}

                        <Paper sx={{ marginTop: "0.75rem" }} />
                        {renderDonationProofs()}
                        <Paper sx={{ marginTop: "1.25rem" }} />

                        <HistoryIcon sx={{ verticalAlign: "middle", fontSize: "1.25rem", marginRight: "0.25rem" }} /> {" "}
                        <Link href="/karma/donations" rel="noopener noreferrer" sx={{ verticalAlign: "middle" }}>
                            <strong>View Full History</strong>
                        </Link>
                    </Typography>
                    </Box>
                </Box>
            </Box>
            <Paper sx={{ marginTop: "2.25rem" }} />
        </>
    );
}

export default DashboardPool;


